/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Akses_TInputs */

const en_tut_akses_t = /** @type {(inputs: Tut_Akses_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who may enter: area access and knocking`)
};

const id_tut_akses_t = /** @type {(inputs: Tut_Akses_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Siapa boleh masuk: akses area dan ketuk pintu`)
};

/**
* | output |
* | --- |
* | "Who may enter: area access and knocking" |
*
* @param {Tut_Akses_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_akses_t = /** @type {((inputs?: Tut_Akses_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Akses_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_akses_t(inputs)
	return en_tut_akses_t(inputs)
});